import React from "react";
import _ from "lodash";
import {Comparison} from "./comparison";

export function teamComparisonUrl(ids) {
    let newIds = _.join(_.slice(ids, 0, 6), '-');
    return "/teamcomparison/" + newIds;
}

export const TeamComparison = () => <Comparison type="team"/>;